import tools from '../../tools';
import TableRowComponent from './components/TableRowComponent';
import TableCellComponent from './components/TableCellComponent';
import type { EditorPlugin } from '../../types/aha-editor';
import TableNormalizationPlugin from './TableNormalization';
import TableKeyPlugin from './TableKeyPlugin';
import { type Editor } from 'slate';
import TableComponent from './components/TableComponent';
import TableSelectionUpdatePlugin from './TableSelectionUpdatePlugin';
import TableMouseDownPlugin from './TableMouseDownPlugin';
import TableSelection from './TableSelection';
import TableCutCopyPlugin from './TableCutCopyPlugin';
import TableUtils from './TableUtils';

const TablePlugin: EditorPlugin[] = [
  TableNormalizationPlugin,
  TableKeyPlugin,
  TableSelectionUpdatePlugin,
  TableMouseDownPlugin,
  TableCutCopyPlugin,
  {
    name: 'Table initial pluginState',
    setPluginState: (pluginState: Record<string, any>, editor: Editor) => {
      pluginState.tableSelection = new TableSelection({ editor });
    },
  },
  {
    name: 'Table component',
    components: [
      {
        type: 'table',
        component: TableComponent,
        toolbarItems: [
          [tools.ToolInsertRowsOrColumns, tools.ToolDeleteRowsOrColumns],
          [tools.ToolCellBackgroundColor, tools.ToolTableBorderColor],
          [tools.ToolTableAlternateRowColor],
          [tools.ToolCellAlign],
          [tools.ToolMergeCells, tools.ToolSplitCells],
          [tools.ToolTableSortOptions],
          [tools.ToolTableOptions],
        ],
      },
      {
        type: 'table-row',
        component: TableRowComponent,
      },
      {
        type: 'table-cell',
        component: TableCellComponent,
      },
    ],
  },
];

export default TablePlugin;

export { TableUtils };
